<template>
  <b-card title="کیف‌پول کاربران">
    <b-row>
      <b-col class="table-size">
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-col md="3">
                <b-form-group
                  label="موبایل"
                  label-for="Mobile"
                >
                  <b-form-input
                    v-model="filterOptions.Mobile"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="فقط دارای موجودی"
                  label-for="HasBalance"
                >
                  <v-select
                    v-model="filterOptions.HasBalance"
                    :options="yesNoOptions"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(User)="data">
            <span>{{ ((data.item.UserName || '') + ' ' + (data.item.UserFamily || '')).trim() || '—' }}</span>
          </template>

          <template #cell(Balance)="data">
            <span class="text-nowrap font-weight-bold">{{ money(data.value) }}</span>
          </template>

          <template #cell(BlockedBalance)="data">
            <span class="text-nowrap">{{ money(data.value) }}</span>
          </template>

          <template #cell(UpdatedAt)="data">
            <span class="text-nowrap">{{ data.value ? $options.filters.date(data.value, 'date-time') : '—' }}</span>
          </template>

          <template #cell(actions)="data">
            <div class="text-nowrap">
              <feather-icon
                icon="ListIcon"
                size="16"
                class="cursor-pointer"
                @click="openTransactions(data.item)"
              />
            </div>
          </template>

          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :per-page.sync="filterOptions.PerPage"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />
      </b-col>
    </b-row>

    <!-- تراکنش‌ها -->
    <b-modal
      v-if="showTx"
      v-model="showTx"
      centered
      hide-footer
      size="lg"
      :title="txTitle"
      :no-close-on-backdrop="true"
    >
      <b-row class="mb-1">
        <b-col md="5">
          <v-select
            v-model="txFilter.Type"
            :options="typeOptions"
            dir="rtl"
            label="text"
            placeholder="نوع تراکنش"
            :reduce="x => x.value"
            @input="loadTransactions(1)"
          />
        </b-col>
      </b-row>

      <b-table
        bordered
        hover
        striped
        :items="txItems"
        :fields="txFields"
        class="mt-1 mb-2 position-relative"
        responsive
        :busy="txLoading"
        show-empty
        empty-text="تراکنشی یافت نشد"
      >
        <template #cell(Type)="data">
          <b-badge :variant="typeVariant(data.value)">{{ typeText(data.value) }}</b-badge>
        </template>

        <template #cell(Amount)="data">
          <span class="text-nowrap">{{ money(data.value) }}</span>
        </template>

        <template #cell(BalanceAfter)="data">
          <span class="text-nowrap">{{ money(data.value) }}</span>
        </template>

        <template #cell(Status)="data">
          <b-badge :variant="txStatusVariant(data.value)">{{ txStatusText(data.value) }}</b-badge>
        </template>

        <template #cell(CreatedAt)="data">
          <span class="text-nowrap">{{ data.value | date('date-time') }}</span>
        </template>

        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner
              variant="primary"
              class="align-middle"
            />
          </div>
        </template>
      </b-table>

      <z-pagination
        :page="txFilter.Page"
        :per-page.sync="txFilter.PerPage"
        :total-rows="txTotalRows"
        :loading="txLoading"
        @change="loadTransactions"
      />
    </b-modal>
  </b-card>
</template>

<script>
export default {
  name: 'Wallet',
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Mobile: null,
        HasBalance: null,
        Page: 1,
        PerPage: 10,
      },
      yesNoOptions: [
        { text: 'بله', value: true },
        { text: 'خیر', value: false },
      ],
      typeOptions: [
        { text: 'واریز', value: 0 },
        { text: 'پرداخت رزرو', value: 1 },
        { text: 'بازگشت رزرو', value: 2 },
        { text: 'درآمد مشاوره', value: 3 },
        { text: 'برداشت', value: 4 },
      ],
      items: [],
      fields: [
        { key: 'UserId', label: '#', thClass: 'col-width-50' },
        { key: 'User', label: 'کاربر' },
        { key: 'Mobile', label: 'موبایل' },
        { key: 'Balance', label: 'موجودی (تومان)' },
        { key: 'BlockedBalance', label: 'بلاک‌شده' },
        { key: 'UpdatedAt', label: 'آخرین تغییر' },
        { key: 'actions', label: '', thClass: 'col-width-50' },
      ],
      showTx: false,
      txTitle: '',
      txItems: [],
      txLoading: false,
      txTotalRows: 1000 * 1000,
      txFilter: {
        UserId: null,
        Type: null,
        Page: 1,
        PerPage: 10,
      },
      txFields: [
        { key: 'Id', label: '#', thClass: 'col-width-50' },
        { key: 'Type', label: 'نوع' },
        { key: 'Amount', label: 'مبلغ' },
        { key: 'BalanceAfter', label: 'موجودی پس از' },
        { key: 'Status', label: 'وضعیت' },
        { key: 'Description', label: 'توضیحات' },
        { key: 'CreatedAt', label: 'تاریخ' },
      ],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    money(value) {
      if (value == null) return '۰'
      return Number(value).toLocaleString('fa-IR')
    },
    typeText(value) {
      return ['واریز', 'پرداخت رزرو', 'بازگشت رزرو', 'درآمد مشاوره', 'برداشت'][value] || '—'
    },
    typeVariant(value) {
      return ['light-success', 'light-danger', 'light-info', 'light-success', 'light-warning'][value] || 'light-secondary'
    },
    txStatusText(value) {
      return ['در انتظار', 'موفق', 'ناموفق', 'لغوشده'][value] || '—'
    },
    txStatusVariant(value) {
      return ['light-warning', 'light-success', 'light-danger', 'light-secondary'][value] || 'light-secondary'
    },
    update(pageNumber) {
      this.loading = true
      this.filterOptions.Page = pageNumber || this.filterOptions.Page
      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(this.$api.wallet.getlist, this.filterOptions)
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    openTransactions(item) {
      this.txTitle = `تراکنش‌های ${(item.UserName || '') + ' ' + (item.UserFamily || '')} (${item.Mobile})`
      this.txFilter = {
        UserId: item.UserId,
        Type: null,
        Page: 1,
        PerPage: 10,
      }
      this.txItems = []
      this.showTx = true
      this.loadTransactions(1)
    },
    loadTransactions(pageNumber) {
      this.txLoading = true
      this.txFilter.Page = pageNumber || this.txFilter.Page

      this.$http.post(this.$api.wallet.transactions, this.txFilter)
        .then(res => {
          this.txTotalRows = res.totalRow
          this.txItems = res.data
        })
        .finally(() => {
          this.txLoading = false
        })
    },
  },
}
</script>
